import Repository from "./Repository";

export default {
  sendEmailFan(payload) {
    console.log(payload);
    return Repository.post("/fan/send-email", payload);
  },
};
